import { render, staticRenderFns } from "./OptixLabAnalyzer.vue?vue&type=template&id=385704f8&scoped=true"
import script from "./OptixLabAnalyzer.vue?vue&type=script&lang=js"
export * from "./OptixLabAnalyzer.vue?vue&type=script&lang=js"
import style0 from "./OptixLabAnalyzer.vue?vue&type=style&index=0&id=385704f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385704f8",
  null
  
)

export default component.exports